export type Basemap = "site" | "osm";

export const BASEMAP_STORAGE_KEY = "machineMap.basemap";

export function readStoredBasemap(): Basemap | null {
  try {
    const stored = localStorage.getItem(BASEMAP_STORAGE_KEY);
    return stored === "site" || stored === "osm" ? stored : null;
  } catch {
    return null;
  }
}

export function storeBasemap(basemap: Basemap): void {
  try {
    localStorage.setItem(BASEMAP_STORAGE_KEY, basemap);
  } catch {
    // Note: storage can be blocked or full; the choice still applies for this visit.
  }
}

export function resolveBasemap(stored: Basemap | null, featuresSettled: boolean, featureCount: number): Basemap | null {
  if (stored) return stored;
  if (!featuresSettled) return null;
  return featureCount > 0 ? "site" : "osm";
}
